import React from 'react';
import { EyeIcon, ClockIcon, BadgeCheck, CheckCircle } from 'lucide-react';
const HeaderGlpAdv3 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17589" data-mp="zphvha26lks0">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17590" data-mp="uvnfaglsbnxo"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17591" data-mp="py427k0tph7b">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17592" data-mp="ly3cv4c6rllh">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17593" data-mp="gxyv7azjkkto">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17594" data-mp="bznkyz5c48ax">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17595" data-mp="26d5aust7ph94">
          <div className="text-left" data-id="element-17596" data-mp="21ebv0tqgde5s">HEALTH & WELLNESS</div>
          <div className="text-left sm:text-center" data-id="element-17597" data-mp="1eyexl3co0s57">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17598" data-mp="1xqh77uqw385y">GLP-1 SUPPORT</div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17599" data-mp="22nzk1w8127j8">
        <div className="max-w-4xl mx-auto" data-id="element-17600" data-mp="1o0efdxvi8097">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17601" data-mp="1nxjwias52nhw">
            PATIENT STORY
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-17602" data-mp="2gn8wqlx0yjig">
            "I Was About To Give Up My GLP-1 Weight Loss Until A Bariatric
            Specialist Revealed What The Shot Was Actually Doing To My Brain"
          </h1>

          <div className="my-6" data-id="element-17603" data-mp="2qc5wj7ke46a3">
            <img src="https://cdn.magicpatterns.com/uploads/bao2rn4NRkKGyXaiJg6Dqg/Untitled_(700_x_500_px)_(3).png" alt="Before and after transformation" className="w-full h-auto rounded-sm" data-id="element-17604" data-mp="2qd7i45z18b62" />
          </div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-17605" data-mp="2haptxlzth8gf">
            GLP-1 Reward-System Fix Backed By Vanderbilt Research That's Helped
            36,700+ Women Stay On Their Shot — Without The Dread, The Numbness,
            Or The Panic Attacks
          </p>

          {/* Author Byline */}
          <div className="flex items-center gap-3 mb-0 pb-5 border-b border-gray-200" data-id="element-17606" data-mp="1yl01h5jj0yro">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-17607" data-mp="1tlnd2gd0bjmz">
              <img src="https://cdn.magicpatterns.com/uploads/dZsfYoUn5AK95fR4SRF9oa/YCyEt6vcI9ES0sqc36Qz6.png" alt="Patient" className="w-full h-full object-cover" data-id="element-17608" data-mp="1omk8ex0xvffj" />
            </div>
            <div className="flex-1" data-id="element-17609" data-mp="46m8rm0uo7t0">
              <div className="flex items-center gap-1 mb-1" data-id="element-17610" data-mp="9332qwuqdge0">
                <span className="text-sm font-medium text-gray-900" data-id="element-17611" data-mp="95fkpa0hnqr2">
                  Written By Celine O'Neill
                </span>
                <BadgeCheck className="h-4 w-4 text-blue-600" data-id="element-17612" data-mp="i4suy4wfsjcu" />
              </div>
              <div className="text-xs text-gray-600 mb-1" data-id="element-17613" data-mp="3hjo69y4lfh9q">
                Verified GLP-1 User • 11 Months on Treatment
              </div>
              <div className="flex items-center gap-3 text-xs text-gray-500" data-id="element-17614" data-mp="3mjaj46gievi0">
                <div className="flex items-center gap-1" data-id="element-17615" data-mp="3qjufh7t9dv33">
                  <ClockIcon className="h-3 w-3" data-id="element-17616" data-mp="3qi9m3lioki6t" />
                  <span data-id="element-17617" data-mp="3vbul9gw0fi7l">12 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-17618" data-mp="2ysws8j9nv2p0">
                  <EyeIcon className="h-3 w-3" data-id="element-17619" data-mp="2yset9evm6ade" />
                  <span data-id="element-17620" data-mp="32u9t0exwcfp2">28,341 views</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpAdv3;